<template>
  <q-page class="window-height window-width row justify-center items-center">
    <div class="column">
      <div class="row">
        <q-form @submit.prevent="sendPasswordReset" ref="formLogin" v-if="!token">
          <q-linear-progress indeterminate color="green-10" v-if="loading" />
          <q-card square bordered class="q-pa-lg shadow-1">
            <img alt="Super Simples logo" src="@/assets/logo.jpg">
            <div class="row justify-center">
              <h5 class="text-h5 q-my-md">Esqueci minha senha</h5>
            </div>
            <q-card-section class="q-gutter-md" v-if="showSuccessMessage">
              <q-banner class="bg-green text-white">
                {{message}}
              </q-banner>
            </q-card-section>
            <q-card-section class="q-gutter-md">
              <q-input 
                square 
                filled 
                v-model="formForgetPassword.email" 
                type="email" 
                label="Email"
                color="green-10"
                :rules="[
                  val => isValidMail(val) || 'Digite um email válido'
                ]"
              />
            </q-card-section>
            <q-card-actions class="q-px-md">
              <q-btn unelevated color="green-10" type="submit" size="lg" class="full-width" label="OK" />
            </q-card-actions>
          </q-card>
        </q-form>
        <q-form @submit.prevent="reset" ref="formLogin" v-if="token">
          <q-linear-progress indeterminate color="green-10" v-if="loading" />
          <q-card square bordered class="q-pa-lg shadow-1">
            <img alt="Super Simples logo" src="@/assets/logo.jpg">
            <div class="row justify-center">
              <h5 class="text-h5 q-my-md">Redefinição de senha</h5>
            </div>
            <q-card-section class="q-gutter-md" v-if="showSuccessMessage">
              <q-banner class="bg-green text-white">
                {{message}}
              </q-banner>
            </q-card-section>
            <q-card-section class="q-gutter-md">
              <q-input 
                square 
                filled 
                v-model="auth.senha" 
                type="password" 
                label="Nova senha"
                color="green-10"
                :rules="[
                  val => !!val || 'O campo nova senha é obrigatório'
                ]"
              />
              <q-input 
                square 
                filled 
                v-model="auth.confirmacaoSenha" 
                type="password" 
                label="Confirmar senha"
                color="green-10"
                :rules="[
                  val => !!val || 'O campo confirmação de senha é obrigatório',
                  val => val === auth.senha || 'A confirmação de senha deve ser igual a senha'
                ]"
              />
            </q-card-section>
            <q-card-actions class="q-px-md">
              <q-btn unelevated color="green-10" type="submit" size="lg" class="full-width" label="OK" />
            </q-card-actions>
          </q-card>
        </q-form>
      </div>
    </div>
  </q-page>
  <!-- <div>
    <b-container fluid>
      <b-row>
        <b-col />
        <b-col md="6" lg="4" sm="12">
          <b-card no-body class="overflow-hidden" style="max-width: 540px;">
            <b-progress v-if="loading" height="5px" striped :animated="true" :value="100"></b-progress>
            <b-row no-gutters>
              <b-col cols="12" md="12">
                <b-card-img src="@/assets/logo.jpg" style="padding: 15px;" alt="Image" class="rounded-0"></b-card-img>
              </b-col>
              <b-col cols="12" md="12">
                <b-card-body :title="token ? 'Redefinição de senha' : 'Esqueci minha senha'" style="text-align: center;">
                  <b-card-text>
                    <b-form role="group" style="text-align: left;" @submit.prevent="reset" v-if="token">
                      <b-form-group>
                        <label for="input-password">Senha:</label>
                        <b-form-input
                          id="input-password"
                          v-model="auth.senha"
                          type="password"
                          placeholder="Digite a senha"
                          @input="$v.auth.senha.$touch"
                        ></b-form-input>
                        <b-form-text text-variant="danger" v-if="!$v.auth.senha.required && $v.auth.senha.$dirty">
                          O campo senha é obrigatório.
                        </b-form-text>
                      </b-form-group> 
                      <b-form-group>
                        <label for="input-password">Confirme a senha:</label>
                        <b-form-input
                          id="input-password-confirm"
                          v-model="auth.confirmacaoSenha"
                          type="password"
                          placeholder="Digite a senha"
                          @input="$v.auth.confirmacaoSenha.$touch"
                        ></b-form-input>
                        <b-form-text text-variant="danger" v-if="!$v.auth.confirmacaoSenha.required && $v.auth.confirmacaoSenha.$dirty">
                          O campo confirmação de senha é obrigatório.
                        </b-form-text>
                        <b-form-text text-variant="danger" v-if="(auth.senha !== auth.confirmacaoSenha)">
                          A confirmação de senha deve ser igual a senha.
                        </b-form-text>
                      </b-form-group> 
                      <b-button :disabled="$v.auth.$invalid || this.loading" type="submit" variant="success">OK</b-button>
                    </b-form>
                    <b-form role="group" style="text-align: left;" @submit.prevent="sendPasswordReset" v-else>
                      <b-alert variant="success" v-if="showSuccessMessage" show>{{message}}</b-alert>
                      <div v-else>
                        <b-form-group>
                        <label for="input-email">Email:</label>
                        <b-form-input
                          id="input-email"
                          v-model="formForgetPassword.email"
                          type="email"
                          placeholder="Digite seu email"
                          @input="$v.formForgetPassword.email.$touch"
                        ></b-form-input>
                        <b-form-text text-variant="danger" v-if="!$v.formForgetPassword.email.required && $v.formForgetPassword.email.$dirty">
                          O campo email é obrigatório.
                        </b-form-text>
                        <b-form-text text-variant="danger" v-if="!$v.formForgetPassword.email.email && $v.formForgetPassword.email.$dirty">
                          Deve ser um email válido.
                        </b-form-text>
                      </b-form-group> 
                      <b-button :disabled="$v.formForgetPassword.$invalid || this.loading" type="submit" variant="success">OK</b-button>
                      </div>
                    </b-form>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col />
      </b-row>
    </b-container>
  </div> -->
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { 
  resetPassword,
  createPasswordReset
} from '../../services/usuario'

export default {
  data: () => {
    return {
      auth: {
        senha: '',
        confirmacaoSenha: ''
      },
      formForgetPassword: {
        email: ''
      },
      showSuccessMessage: false,
      message: '',
      loading: false
    }
  },
  mounted () {
    if (this.usuarioLogado.email) {
      this.auth.email = this.usuarioLogado.email
    }
  },
  methods: {
    async reset () {
      try {
        this.loading = true
        const data = { token: this.token, senha: this.auth.senha }
        const { email } = await resetPassword(data)
        this.$store.dispatch('setUsuario', { email })
        this.$router.push({ name: 'Login' })
        this.$q.notify({
          color: 'green',
          position: 'top-right',
          icon: 'check',
          message: 'Sua senha foi alterada com sucesso!'
        })
      } catch (error) {
        console.error(error)
        this.$q.notify({
          color: 'red',
          position: 'top-right',
          icon: 'report_problem',
          message: error.message
        })
      } finally {
        this.loading = false
      }
    },

    async sendPasswordReset () {
      try {
        this.loading = true
        const response = await createPasswordReset({ email: this.formForgetPassword.email })
        this.showSuccessMessage = true
        this.message = response
      } catch (error) {
        console.error(error)
        this.$bvToast.toast(error.message, {
          title: 'SRCAL',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loading = false
      }
    },

    isValidMail (val) {
      return val && val.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/im)
    }
  },
  computed: {
    usuarioLogado () {
      return this.$store.getters.getUsuario
    },
    token () {
      return this.$route.query.token
    }
  },
  validations: {
    auth: {
      senha: {
        required
      },
      confirmacaoSenha: {
        required
      }
    },
    formForgetPassword: {
      email: {
        required,
        email
      }
    }
  }
}
</script>

<style scoped>
  .btn-success {
    background-color: #255d46 !important;
    border-color: #255d46 !important;
  }
</style>